"use client";

import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
import { setStoreReduxBlog } from "../../reducer/blogSlice";
import axios from "axios";
import { FiArrowRight } from "react-icons/fi";

export default function AboutPage() {
  // const backend_domain_name = `https://bicadmin.z256600-ll9lz.ps02.zwhhosting.com`;
  const new_backend_domain_name = `https://bi.oasisyangonmm.com`
  const [isLoading, setIsLoading] = useState(true);

  const [blogs, setBlogs] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${new_backend_domain_name}/api/blogs`);
      if (response.status == 200) {
        console.log(response.data);
        // dispatch(setStoreReduxBlog(response.data.data));
        setBlogs(response.data.data);
      } else {
        console.log("error");
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error in fetchApi:", error);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    fetchData();
  }, []);

   const universityData = {
  uk: [
    { name: "University of Oxford", logo: "oxford.webp" },
    { name: "University of Cambridge", logo: "cambridge.jpg" },
    { name: "Imperial College London", logo: "imperial.jpg" },
    { name: "University College London (UCL)", logo: "ucl.png" },
    { name: "London School of Economics (LSE)", logo: "lse.webp" },
    { name: "University of Edinburgh", logo: "edinburgh.webp" },
    { name: "King's College London", logo: "king.webp" },
    { name: "University of Manchester", logo: "manchester.jpg" },
    { name: "University of Warwick", logo: "warwick.webp" },
    { name: "University of Bristol", logo: "newBristo.png" }
  ],
  canada: [
    { name: "University of Toronto", logo: "toronto.webp" },
    { name: "McGill University", logo: "mcgill.png" },
    { name: "University of British Columbia (UBC)", logo: "ubc.png" },
    { name: "University of Waterloo", logo: "waterloo.webp" },
    { name: "McMaster University", logo: "mcmaster.jpg" },
    { name: "University of Alberta", logo: "alberta.webp" },
    { name: "Western University", logo: "western.webp" },
    { name: "Queen's University", logo: "queen.webp" },
    { name: "Université de Montréal", logo: "montreal.png" }
  ],
  europe: [
    { name: "ETH Zurich (Switzerland)", logo: "eth.jpg" },
    { name: "EPFL (Switzerland)", logo: "epfl.webp" },
    { name: "PSL University (France)", logo: "psl.png" },
    { name: "Sorbonne University (France)", logo: "sorbonne.webp" },
    { name: "TU Delft (Netherlands)", logo: "tudelft.png" },
    { name: "University of Amsterdam", logo: "amsterdam.jpg" },
    { name: "Technical University of Munich", logo: "tum.webp" },
    { name: "LMU Munich", logo: "lmuNew.png" },
    { name: "Heidelberg University", logo: "heidelberg.webp" },
    { name: "KU Leuven", logo: "kuleuven.jpg" },
    { name: "University of Copenhagen", logo: "copenhagen.jpg" },
    { name: "Karolinska Institute", logo: "karolinska.jpeg" },
    { name: "Trinity College Dublin", logo: "trinity.webp" }
  ],
  asia: [
    { name: "Tsinghua University", logo: "tsinghua.png" },
    { name: "Peking University", logo: "peking.png" },
    { name: "Fudan University", logo: "fudan.png" },
    { name: "Shanghai Jiao Tong University", logo: "shanghai.png" },
    { name: "Zhejiang University", logo: "zhejiang.webp" },
    { name: "National University of Singapore", logo: "nus.jpg" },
    { name: "University of Melbourne", logo: "melbourne.jpg" },
    { name: "University of Sydney", logo: "sydney.webp" },
    { name: "Australian National University", logo: "aus.webp" },
    { name: "University of New South Wales", logo: "unsw.png" },
    { name: "Monash University", logo: "monash.png" }
  ]
};


  const { hash } =  useLocation();

  useEffect(() => {
if (hash) {
    // ဓာတ်ပုံ သို့မဟုတ် အခြား Data များ load ဖြစ်ချိန်ကို စောင့်ရန် Timeout ခံထားခြင်း ဖြစ်သည်
    const timer = setTimeout(() => {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      } else {
        console.log(`Element with id ${id} not found yet.`);
      }
    }, 1500); 

    return () => clearTimeout(timer); // Component Unmount ဖြစ်လျှင် Timer ကို ဖျက်ရန်
  }
  }, [hash]);

  const SkeletonLoader = () => (
    <div className="relative min-h-screen bg-dark-primary">
      {/* Hero Section Skeleton */}
      <section className="relative w-full h-screen flex items-end justify-start overflow-hidden">
        <div className="absolute inset-0 bg-gray-800 animate-pulse">
          <div className="absolute inset-0 bg-gradient-to-r from-gray-800 via-gray-700 to-gray-800 animate-shimmer"></div>
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-brand-red/10 to-black/90"></div>
        <div className="relative z-10 max-w-2xl text-left px-6 md:px-12 pb-16 md:pb-24 space-y-6">
          <div className="h-16 md:h-20 bg-gray-700 rounded-lg animate-pulse"></div>
          <div className="w-24 h-1 bg-gray-600 rounded-full animate-pulse"></div>
          <div className="space-y-3">
            <div className="h-6 bg-gray-700 rounded animate-pulse"></div>
            <div className="h-6 bg-gray-700 rounded animate-pulse w-4/5"></div>
            <div className="h-6 bg-gray-700 rounded animate-pulse w-3/4"></div>
          </div>
        </div>
      </section>

      {/* Full Width Image Skeleton */}
      <section className="w-full relative overflow-hidden">
        <div className="relative h-[100vh] md:h-[100vh]">
          <div className="w-full h-full bg-gray-800 animate-pulse relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-gray-700 via-gray-600 to-gray-800 animate-shimmer"></div>
            <div className="absolute inset-0 bg-gradient-to-t from-gray-900/50 to-transparent"></div>
          </div>
          <div
            className="absolute bottom-0 left-0 w-full h-40 md:h-48"
            style={{
              background: "#82062c",
              clipPath: "polygon(0 100%, 0 0, 100% 100%, 100% 100%)",
            }}
          ></div>
        </div>
      </section>

      {/* Founders Experience Skeleton */}
      <section className="w-full flex flex-col lg:flex-row items-stretch min-h-screen">
        <div className="w-full lg:w-1/2 relative">
          <div className="w-full h-full bg-gray-800 animate-pulse min-h-[500px] lg:min-h-full relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-gray-700 via-gray-600 to-gray-700 animate-shimmer"></div>
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-gray-500/20 to-gray-600/30"></div>
          </div>
        </div>
        <div className="w-full lg:w-1/2 bg-dark-blue flex items-center">
          <div className="p-8 md:p-16 lg:p-20 space-y-8 w-full">
            <div className="space-y-4">
              <div className="w-16 h-1 bg-gray-600 rounded-full animate-pulse"></div>
              <div className="h-16 bg-gray-700 rounded-lg animate-pulse"></div>
            </div>
            <div className="space-y-3">
              <div className="h-6 bg-gray-700 rounded animate-pulse"></div>
              <div className="h-6 bg-gray-700 rounded animate-pulse w-5/6"></div>
              <div className="h-6 bg-gray-700 rounded animate-pulse w-4/5"></div>
              <div className="h-6 bg-gray-700 rounded animate-pulse w-3/4"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Philosophy Section Skeleton */}
      <section className="w-full flex flex-col-reverse lg:flex-row items-stretch min-h-screen">
        <div className="w-full lg:w-1/2 bg-gray-800 flex items-center">
          <div className="p-8 md:p-16 lg:p-20 space-y-8 w-full">
            <div className="space-y-4">
              <div className="w-16 h-1 bg-gray-600 rounded-full animate-pulse"></div>
              <div className="h-16 bg-gray-700 rounded-lg animate-pulse"></div>
            </div>
            <div className="space-y-3">
              <div className="h-6 bg-gray-700 rounded animate-pulse"></div>
              <div className="h-6 bg-gray-700 rounded animate-pulse w-5/6"></div>
              <div className="h-6 bg-gray-700 rounded animate-pulse w-4/5"></div>
            </div>
          </div>
        </div>
        <div className="w-full lg:w-1/2 relative">
          <div className="w-full h-full bg-gray-800 animate-pulse min-h-[500px] lg:min-h-full relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-l from-gray-700 via-gray-600 to-gray-700 animate-shimmer"></div>
            <div className="absolute inset-0 bg-gradient-to-l from-transparent via-gray-500/20 to-gray-600/30"></div>
          </div>
        </div>
      </section>

      {/* History Section Skeleton */}
      <section className="w-full flex flex-col lg:flex-row items-stretch min-h-screen">
        <div className="w-full lg:w-1/2 relative">
          <div className="w-full h-full bg-gray-800 animate-pulse min-h-[500px] lg:min-h-full relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-gray-700 via-gray-600 to-gray-700 animate-shimmer"></div>
            <div className="absolute inset-0 bg-gradient-to-r from-transparent to-gray-600/25"></div>
          </div>
        </div>
        <div className="w-full lg:w-1/2 relative bg-gray-900">
          <div className="absolute inset-0 opacity-5">
            <div className="w-full h-full bg-gray-700 animate-pulse relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-gray-600 via-gray-500 to-gray-600 animate-shimmer"></div>
            </div>
          </div>
          <div className="relative z-10 p-8 md:p-16 lg:p-20 flex flex-col justify-center h-full space-y-8">
            <div className="space-y-4">
              <div className="w-16 h-1 bg-gray-600 rounded-full animate-pulse"></div>
              <div className="h-16 bg-gray-700 rounded-lg animate-pulse"></div>
            </div>
            <div className="space-y-3">
              <div className="h-6 bg-gray-700 rounded animate-pulse"></div>
              <div className="h-6 bg-gray-700 rounded animate-pulse w-5/6"></div>
              <div className="h-6 bg-gray-700 rounded animate-pulse w-4/5"></div>
            </div>
            <div className="pt-4">
              <div className="h-6 bg-gray-700 rounded animate-pulse w-48"></div>
            </div>
          </div>
        </div>
      </section>




      {/* Values Section Skeleton */}
      <section className="w-full py-20 md:py-32 px-4 md:px-6 bg-gray-900 relative">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16 md:mb-24 space-y-6">
            <div className="w-20 h-1 bg-gray-600 mx-auto rounded-full animate-pulse"></div>
            <div className="h-16 bg-gray-700 rounded-lg animate-pulse max-w-md mx-auto"></div>
            <div className="h-6 bg-gray-700 rounded animate-pulse max-w-2xl mx-auto"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 lg:gap-20">
            {[1, 2, 3, 4].map((item) => (
              <div key={item} className="space-y-6">
                <div className="flex items-start space-x-6">
                  <div className="flex-shrink-0 w-16 h-16 bg-gray-700 rounded-2xl animate-pulse"></div>
                  <div className="flex-1 space-y-4">
                    <div className="h-8 bg-gray-700 rounded animate-pulse"></div>
                    <div className="space-y-2">
                      <div className="h-4 bg-gray-700 rounded animate-pulse"></div>
                      <div className="h-4 bg-gray-700 rounded animate-pulse w-5/6"></div>
                      <div className="h-4 bg-gray-700 rounded animate-pulse w-4/5"></div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* News Section Skeleton */}
      <section className="w-full py-20 md:py-32 px-4 md:px-6 bg-dark-blue relative">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16 md:mb-20 space-y-6">
            <div className="w-20 h-1 bg-gray-600 mx-auto animate-pulse"></div>
            <div className="h-16 bg-gray-700 rounded-lg animate-pulse max-w-md mx-auto"></div>
            <div className="h-6 bg-gray-700 rounded animate-pulse max-w-2xl mx-auto"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
            {[1, 2, 3].map((item) => (
              <div
                key={item}
                className="bg-gray-900 overflow-hidden shadow-2xl"
              >
                <div className="relative h-64 overflow-hidden">
                  <div className="w-full h-full bg-gray-800 animate-pulse relative overflow-hidden">
                    <div className="absolute inset-0 bg-gradient-to-br from-gray-700 via-gray-600 to-gray-800 animate-shimmer"></div>
                  </div>
                  <div className="absolute top-4 left-4">
                    <div className="bg-gray-700 w-20 h-6 animate-pulse"></div>
                  </div>
                </div>
                <div className="p-6 md:p-8 space-y-4">
                  <div className="h-8 bg-gray-700 rounded animate-pulse"></div>
                  <div className="space-y-2">
                    <div className="h-4 bg-gray-700 rounded animate-pulse"></div>
                    <div className="h-4 bg-gray-700 rounded animate-pulse w-5/6"></div>
                    <div className="h-4 bg-gray-700 rounded animate-pulse w-4/5"></div>
                  </div>
                  <div className="flex items-center justify-between pt-4">
                    <div className="h-4 bg-gray-700 rounded animate-pulse w-24"></div>
                    <div className="w-8 h-8 bg-gray-700 animate-pulse"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section Skeleton */}
      <section className="w-full relative min-h-screen flex items-center">
        <div className="absolute inset-0 bg-gray-800 animate-pulse relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-gray-700 via-gray-600 to-gray-900 animate-shimmer"></div>
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-brand-red/30 to-black/90"></div>
        <div className="relative z-10 w-full py-20 md:py-32 px-4 md:px-6">
          <div className="max-w-5xl mx-auto text-center space-y-10 md:space-y-12">
            <div className="h-20 md:h-24 bg-gray-700 rounded-lg animate-pulse max-w-2xl mx-auto"></div>
            <div className="space-y-3 max-w-4xl mx-auto">
              <div className="h-8 bg-gray-700 rounded animate-pulse"></div>
              <div className="h-8 bg-gray-700 rounded animate-pulse w-5/6 mx-auto"></div>
              <div className="h-8 bg-gray-700 rounded animate-pulse w-4/5 mx-auto"></div>
            </div>
            <div className="pt-8">
              <div className="h-16 bg-gray-700 rounded-lg animate-pulse w-48 mx-auto"></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );

  if (isLoading) {
    return <SkeletonLoader />;
  }

  return (
    <div className="relative min-h-screen bg-dark-primary">

    
      <section className="w-full flex flex-col lg:flex-row items-stretch min-h-screen">
        {/* Left side: Image */}
        <div className="w-full lg:w-1/2 relative">
          <img
            src="class/classroom3.jpg"
            alt="Educational Leadership and Vision"
            className="w-full h-full object-cover min-h-[500px] lg:min-h-full"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-brand-red/10 to-brand-red/30"></div>
        </div>

        {/* Right side: Text content */}
        <div className="w-full lg:w-1/2 bg-dark-blue flex items-center">
          <div className="p-8 md:p-16 lg:p-20 space-y-8">
            <div className="space-y-4">
              <div className="w-16 h-1 bg-brand-red rounded-full"></div>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-lora text-white leading-tight">
                Built on <span className="text-brand-red">Experience</span>
              </h2>
            </div>
            <p className="text-lg md:text-xl text-brand-beige leading-relaxed font-light font-manrope">
              With over 30 years of combined experience, our founders set out to
              build a truly transformative educational experience—one that
              prioritizes academic excellence, practical skills, personal
              growth, and global readiness. We are not just preparing students
              for exams; we are preparing them for life.
            </p>
            
          </div>
        </div>
      </section>
   
<section className="w-full flex flex-col-reverse lg:flex-row items-stretch lg:min-h-[600px]">
  {/* Left side: Text content */}
  <div className="w-full lg:w-1/2 bg-gray-950 flex items-center">
    <div className="p-8 md:p-16 lg:p-20 space-y-8">
      <div className="space-y-4">
        <div className="w-16 h-1 bg-brand-beige rounded-full"></div>
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-lora text-white leading-tight">
          Our <span className="text-brand-red">Philosophy</span>
        </h2>
      </div>
      <p className="text-lg md:text-xl text-brand-beige leading-relaxed font-light font-manrope">
        At BI, we believe that education should be an empowering journey,
        not a one-size-fits-all process. Our commitment is to provide each
        student with the tools, mentorship, and opportunities needed to
        thrive in an ever-changing world. By blending individualized
        learning pathways with a supportive community, we cultivate
        leaders and innovators.
      </p>
    </div>
  </div>

  {/* Right side: Image content with no empty spaces */}
  <div className="w-full lg:w-1/2 bg-gray-950 relative flex items-center justify-center overflow-hidden">
    {/* Main Image: တစ်ပုံလုံးအပြည့်ပေါ်ပြီး အမြင့်ချင်း ကွက်တိဖြစ်နေမည် */}
    <img
      src="ourPhilosophy.jpg"
      alt="Students Engaged in Learning"
      className="w-full h-full max-h-[500px] lg:max-h-none object-contain relative z-10"
    />

    {/* Overlay Gradient */}
    <div className="absolute inset-0 bg-gradient-to-l from-transparent via-brand-red/5 to-brand-red/20 z-20 pointer-events-none"></div>
  </div>
</section>
      {/* Our History Section */}
      <section className="w-full flex flex-col lg:flex-row items-stretch min-h-screen">
        {/* Left side: Image */}
        <div className="w-full lg:w-1/2 relative">
          <img
            src="/historyBi.jpg"
            alt="Historical Educational Foundation"
            className="w-full h-full object-cover min-h-[500px] lg:min-h-full"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-brand-red/25"></div>
        </div>

        {/* Right side: Text content with background */}
        <div className="w-full lg:w-1/2 relative bg-gray-950">
          <div className="absolute inset-0 opacity-5">
            <img
              src="https://bic-bangkok.vercel.app/library3.jpg"
              alt="Vintage Education Background"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="relative z-10 p-8 md:p-16 lg:p-20 flex flex-col justify-center h-full space-y-8">
            <div className="space-y-4">
              <div className="w-16 h-1 bg-brand-red rounded-full"></div>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-lora text-white leading-tight">
                Our <span className="text-brand-red">History</span>
              </h2>
            </div>
            <p className="text-lg md:text-xl text-brand-beige leading-relaxed font-light font-manrope">
          Bridge International (BI) was founded in Bangkok with a clear vision: to create a high-quality pre-university pathway for students seeking global education in a safe and supportive environment. Built on over 30 years of combined educational experience, BI was designed to move beyond traditional teaching by focusing on personalized mentorship and student-centered learning. From the start, our mission has been to prepare students not only for international university entry, but for confidence, independence, and success beyond the classroom. Today, BI continues to serve as a trusted launchpad in Bangkok for students beginning their global academic journey.
            </p>
          </div>
        </div>
      </section>


      


<section id="ncuk-partnership" className="w-full flex flex-col md:flex-row-reverse items-stretch">
  <div className="w-full md:w-1/2 bg-dark-blue flex items-center justify-center p-6">
    <img
      src="https://bic-bangkok.vercel.app/foreigners.jpg"
      alt="MoU Signing Ceremony - Dhurakij Pundit University, NCUK and Bridge International, Bangkok January 2026"
      className="w-full h-auto max-h-[400px] md:max-h-[500px] object-contain"
    />
  </div>

  <div className="w-full md:w-1/2 bg-dark-blue p-6 md:p-10 flex flex-col justify-center space-y-4 md:space-y-5">
    <div className="inline-block px-3 py-1 bg-brand-red/20 rounded-full border border-brand-red/40 w-fit">
      <span className="text-brand-beige font-manrope font-semibold text-[10px] md:text-xs uppercase tracking-widest">
        Accreditations & Partnerships
      </span>
    </div>
    <h2 className="text-xl md:text-3xl font-lora font-semibold leading-tight text-brand-beige">
      A Recognised <span className="text-brand-red">NCUK</span> Study Centre
    </h2>
    <p className="text-sm md:text-base font-manrope text-gray-300 max-w-xl leading-relaxed">
      Bridge International is an official NCUK Study Centre, established in partnership with NCUK and Dhurakij Pundit University (DPU) through a formal Memorandum of Understanding signed in Bangkok in January 2026.
    </p>
    <p className="text-sm md:text-base font-manrope text-gray-400 max-w-xl leading-relaxed">
      This partnership means our students don't just study an international curriculum — they follow a recognised pathway to universities in the UK, Australia, the US and beyond. NCUK qualifications are accepted by leading universities worldwide, and our collaboration with DPU gives students a trusted, accredited route from Bangkok to a global degree.
    </p>
    <p className="text-xs font-manrope text-gray-500 italic max-w-xl">
      MoU Signing Ceremony — Dhurakij Pundit University, NCUK and Bridge International. Bangkok, January 2026.
    </p>
    <div className="flex flex-col sm:flex-row gap-3 pt-3">
      <Link
        to="/ncuk"
        className="px-4 py-2 bg-brand-red hover:bg-red-700 text-white font-semibold text-center rounded-lg shadow-md transition hover-lift font-manrope text-xs md:text-sm inline-flex items-center justify-center gap-2"
      >
        Explore NCUK Pathway
        <FiArrowRight className="w-3 h-3" />
      </Link>
    </div>
  </div>
</section>





{/* <section className="w-full py-20 md:py-32 px-4 md:px-8 bg-gradient-to-b from-dark-blue via-[#0b1329] to-dark-blue relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[-10%] right-[-10%] w-[500px] h-[500px] bg-brand-red/10 rounded-full blur-[120px]"></div>
        <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] bg-brand-beige/5 rounded-full blur-[150px]"></div>
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(255,255,255,0.01)_1px,transparent_1px)] bg-[size:32px_32px]"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16 md:mb-24 flex flex-col items-center">
          <div className="inline-block mb-4 px-4 py-1.5 bg-gradient-to-r from-brand-red/20 to-transparent rounded-full border border-brand-red/30 backdrop-blur-md">
            <span className="text-brand-beige font-manrope font-semibold text-[10px] md:text-xs uppercase tracking-[0.2em]">
              Global Opportunities
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-lora font-normal text-white tracking-tight mb-6">
            University <span className="text-brand-red italic font-medium font-lora">Progression</span>
          </h2>
          <div className="w-12 h-[2px] bg-gradient-to-r from-transparent via-brand-red to-transparent rounded-full mb-6"></div>
          <p className="text-gray-400 font-manrope text-sm md:text-base max-w-2xl mx-auto leading-relaxed font-light">
            Our graduates have progressed to some of the world's most prestigious universities across the globe
          </p>
        </div>

        <div className="mb-16">
          <div className="flex items-center justify-between gap-4 mb-8">
            <div className="flex items-center gap-3">
              <div className="w-[3px] h-6 bg-brand-red rounded-full"></div>
              <h3 className="text-lg md:text-xl font-lora font-medium text-brand-beige tracking-wide">
                United Kingdom
              </h3>
            </div>
            <div className="flex-1 h-[1px] bg-gradient-to-r from-gray-800 via-gray-800/30 to-transparent hidden sm:block"></div>
            <span className="text-[11px] font-manrope font-medium tracking-wider uppercase text-gray-400 bg-white/5 px-3 py-1 rounded-md border border-white/10">
              {universityData.uk.length} Institutions
            </span>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
            {universityData.uk.map((uni, index) => (
              <div
                key={`school-${index + 1}`}
                className="group relative bg-gradient-to-b from-white/[0.04] to-white/[0.01] backdrop-blur-md border border-white/[0.05] hover:border-brand-red/40 rounded-xl overflow-hidden shadow-2xl hover:scale-105 transition-all duration-300 aspect-square cursor-default"
              >
                <img
                  src={uni.logo}
                  alt={uni.name}
                  className="absolute top-1/2 left-1/2 w-full h-full object-cover -translate-x-1/2 -translate-y-1/2 transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "flex";
                  }}
                />

                <div className="hidden absolute inset-0 flex flex-col items-center justify-center p-4 text-center bg-dark-blue/90 z-10 pointer-events-none">
                  <span className="text-xs font-manrope font-medium text-brand-beige line-clamp-2">
                    {uni.name}
                  </span>
                </div>

                <div className="absolute inset-0 rounded-xl pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20">
                  <div className="absolute inset-0 rounded-xl bg-brand-red/10"></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mb-16">
          <div className="flex items-center justify-between gap-4 mb-8">
            <div className="flex items-center gap-3">
              <div className="w-[3px] h-6 bg-brand-red rounded-full"></div>
              <h3 className="text-lg md:text-xl font-lora font-medium text-brand-beige tracking-wide">
                Canada
              </h3>
            </div>
            <div className="flex-1 h-[1px] bg-gradient-to-r from-gray-800 via-gray-800/30 to-transparent hidden sm:block"></div>
            <span className="text-[11px] font-manrope font-medium tracking-wider uppercase text-gray-400 bg-white/5 px-3 py-1 rounded-md border border-white/10">
              {universityData.canada.length} Institutions
            </span>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
            {universityData.canada.map((uni, index) => (
              <div
                key={`school-${index + 1}`}
                className="group relative bg-gradient-to-b from-white/[0.04] to-white/[0.01] backdrop-blur-md border border-white/[0.05] hover:border-brand-red/40 rounded-xl overflow-hidden shadow-2xl hover:scale-105 transition-all duration-300 aspect-square cursor-default"
              >
                <img
                  src={uni.logo}
                  alt={uni.name}
                  className="absolute top-1/2 left-1/2 w-full h-full object-cover -translate-x-1/2 -translate-y-1/2 transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "flex";
                  }}
                />

                <div className="hidden absolute inset-0 flex flex-col items-center justify-center p-4 text-center bg-dark-blue/90 z-10 pointer-events-none">
                  <span className="text-xs font-manrope font-medium text-brand-beige line-clamp-2">
                    {uni.name}
                  </span>
                </div>

                <div className="absolute inset-0 rounded-xl pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20">
                  <div className="absolute inset-0 rounded-xl bg-brand-red/10"></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mb-16">
          <div className="flex items-center justify-between gap-4 mb-8">
            <div className="flex items-center gap-3">
              <div className="w-[3px] h-6 bg-brand-red rounded-full"></div>
              <h3 className="text-lg md:text-xl font-lora font-medium text-brand-beige tracking-wide">
                Europe
              </h3>
            </div>
            <div className="flex-1 h-[1px] bg-gradient-to-r from-gray-800 via-gray-800/30 to-transparent hidden sm:block"></div>
            <span className="text-[11px] font-manrope font-medium tracking-wider uppercase text-gray-400 bg-white/5 px-3 py-1 rounded-md border border-white/10">
              {universityData.europe.length} Institutions
            </span>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
            {universityData.europe.map((uni, index) => (
              <div
                key={`school-${index + 1}`}
                className="group relative bg-gradient-to-b from-white/[0.04] to-white/[0.01] backdrop-blur-md border border-white/[0.05] hover:border-brand-red/40 rounded-xl overflow-hidden shadow-2xl hover:scale-105 transition-all duration-300 aspect-square cursor-default"
              >
                <img
                  src={uni.logo}
                  alt={uni.name}
                  className="absolute top-1/2 left-1/2 w-full h-full object-cover -translate-x-1/2 -translate-y-1/2 transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "flex";
                  }}
                />

                <div className="hidden absolute inset-0 flex flex-col items-center justify-center p-4 text-center bg-dark-blue/90 z-10 pointer-events-none">
                  <span className="text-xs font-manrope font-medium text-brand-beige line-clamp-2">
                    {uni.name}
                  </span>
                </div>

                <div className="absolute inset-0 rounded-xl pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20">
                  <div className="absolute inset-0 rounded-xl bg-brand-red/10"></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div>
          <div className="flex items-center justify-between gap-4 mb-8">
            <div className="flex items-center gap-3">
              <div className="w-[3px] h-6 bg-brand-red rounded-full"></div>
              <h3 className="text-lg md:text-xl font-lora font-medium text-brand-beige tracking-wide">
                Asia & Oceania
              </h3>
            </div>
            <div className="flex-1 h-[1px] bg-gradient-to-r from-gray-800 via-gray-800/30 to-transparent hidden sm:block"></div>
            <span className="text-[11px] font-manrope font-medium tracking-wider uppercase text-gray-400 bg-white/5 px-3 py-1 rounded-md border border-white/10">
              {universityData.asia.length} Institutions
            </span>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
            {universityData.asia.map((uni, index) => (
              <div
                key={`school-${index + 1}`}
                className="group relative bg-gradient-to-b from-white/[0.04] to-white/[0.01] backdrop-blur-md border border-white/[0.05] hover:border-brand-red/40 rounded-xl overflow-hidden shadow-2xl hover:scale-105 transition-all duration-300 aspect-square cursor-default"
              >
                <img
                  src={uni.logo}
                  alt={uni.name}
                  className="absolute top-1/2 left-1/2 w-full h-full object-cover -translate-x-1/2 -translate-y-1/2 transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "flex";
                  }}
                />

                <div className="hidden absolute inset-0 flex flex-col items-center justify-center p-4 text-center bg-dark-blue/90 z-10 pointer-events-none">
                  <span className="text-xs font-manrope font-medium text-brand-beige line-clamp-2">
                    {uni.name}
                  </span>
                </div>

                <div className="absolute inset-0 rounded-xl pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20">
                  <div className="absolute inset-0 rounded-xl bg-brand-red/10"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section> */}
    <section className="w-full py-20 md:py-32 px-4 md:px-8 bg-gradient-to-b from-dark-blue via-[#0b1329] to-dark-blue relative overflow-hidden">
  <div className="absolute inset-0 pointer-events-none">
    <div className="absolute top-[-10%] right-[-10%] w-[500px] h-[500px] bg-brand-red/10 rounded-full blur-[120px]"></div>
    <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] bg-brand-beige/5 rounded-full blur-[150px]"></div>
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(255,255,255,0.01)_1px,transparent_1px)] bg-[size:32px_32px]"></div>
  </div>

  <div className="max-w-7xl mx-auto relative z-10">
    <div className="text-center mb-16 md:mb-24 flex flex-col items-center">
      <div className="inline-block mb-4 px-4 py-1.5 bg-gradient-to-r from-brand-red/20 to-transparent rounded-full border border-brand-red/30 backdrop-blur-md">
        <span className="text-brand-beige font-manrope font-semibold text-[10px] md:text-xs uppercase tracking-[0.2em]">
          Global Opportunities
        </span>
      </div>
      <h2 className="text-3xl md:text-5xl lg:text-6xl font-lora font-normal text-white tracking-tight mb-6">
        University <span className="text-brand-red italic font-medium font-lora">Progression</span>
      </h2>
      <div className="w-12 h-[2px] bg-gradient-to-r from-transparent via-brand-red to-transparent rounded-full mb-6"></div>
      <p className="text-gray-400 font-manrope text-sm md:text-base max-w-2xl mx-auto leading-relaxed font-light">
        Our graduates have progressed to some of the world's most prestigious universities across the globe
      </p>
    </div>

    {/* United Kingdom */}
    <div className="mb-16">
      <div className="flex items-center justify-between gap-4 mb-8">
        <div className="flex items-center gap-3">
          <div className="w-[3px] h-6 bg-brand-red rounded-full"></div>
          <h3 className="text-lg md:text-xl font-lora font-medium text-brand-beige tracking-wide">
            United Kingdom
          </h3>
        </div>
        <div className="flex-1 h-[1px] bg-gradient-to-r from-gray-800 via-gray-800/30 to-transparent hidden sm:block"></div>
        <span className="text-[11px] font-manrope font-medium tracking-wider uppercase text-gray-400 bg-white/5 px-3 py-1 rounded-md border border-white/10">
          {universityData.uk.length}+ Institutions
        </span>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
        {universityData.uk.map((uni, index) => (
          <div
            key={`school-${index + 1}`}
            className="group relative bg-gradient-to-b from-white/[0.04] to-white/[0.01] backdrop-blur-md border border-white/[0.05] hover:border-brand-red/40 rounded-xl overflow-hidden shadow-2xl hover:scale-105 transition-all duration-300 aspect-square cursor-default"
          >
            <img
              src={uni.logo}
              alt={uni.name}
              className="absolute top-1/2 left-1/2 w-full h-full object-cover -translate-x-1/2 -translate-y-1/2 transition-transform duration-300 group-hover:scale-105"
              loading="lazy"
              onError={(e) => {
                e.target.style.display = "none";
                e.target.nextSibling.style.display = "flex";
              }}
            />

            <div className="hidden absolute inset-0 flex flex-col items-center justify-center p-4 text-center bg-dark-blue/90 z-10 pointer-events-none">
              <span className="text-xs font-manrope font-medium text-brand-beige line-clamp-2">
                {uni.name}
              </span>
            </div>

            <div className="absolute inset-0 rounded-xl pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20">
              <div className="absolute inset-0 rounded-xl bg-brand-red/10"></div>
            </div>
          </div>
        ))}

        {/* +More Card - UK */}
    <div className="group relative overflow-hidden rounded-xl border border-white/10 bg-gradient-to-br from-white/[0.06] via-white/[0.03] to-brand-red/10 backdrop-blur-xl shadow-2xl hover:border-brand-red/40 hover:-translate-y-1 hover:shadow-[0_20px_50px_rgba(220,38,38,0.18)] transition-all duration-500 aspect-square flex items-center justify-center cursor-default">
  {/* Background Glow */}
  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
    <div className="absolute inset-0 bg-gradient-to-br from-brand-red/15 via-transparent to-brand-red/5"></div>
  </div>

  {/* Content */}
  <div className="relative z-10 flex flex-col items-center text-center px-4">
    <div className="w-16 h-16 rounded-full border border-brand-red/30 bg-brand-red/10 flex items-center justify-center transition-all duration-500 group-hover:bg-brand-red group-hover:scale-110">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-7 h-7 text-brand-red group-hover:text-white transition-all duration-500 group-hover:rotate-90"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 5v14m7-7H5"
        />
      </svg>
    </div>

    <h4 className="mt-5 text-base font-semibold font-manrope text-brand-beige">
      Many More
    </h4>

    <p className="mt-2 text-xs text-gray-400 leading-relaxed max-w-[160px]">
      We are partnered with many more universities across the globe.
    </p>
  </div>

  {/* Bottom Accent */}
  <div className="absolute bottom-0 left-0 h-1 w-0 bg-brand-red transition-all duration-500 group-hover:w-full"></div>
</div>
      </div>
    </div>

    {/* Canada */}
    <div className="mb-16">
      <div className="flex items-center justify-between gap-4 mb-8">
        <div className="flex items-center gap-3">
          <div className="w-[3px] h-6 bg-brand-red rounded-full"></div>
          <h3 className="text-lg md:text-xl font-lora font-medium text-brand-beige tracking-wide">
            Canada
          </h3>
        </div>
        <div className="flex-1 h-[1px] bg-gradient-to-r from-gray-800 via-gray-800/30 to-transparent hidden sm:block"></div>
        <span className="text-[11px] font-manrope font-medium tracking-wider uppercase text-gray-400 bg-white/5 px-3 py-1 rounded-md border border-white/10">
          {universityData.canada.length}+ Institutions
        </span>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
        {universityData.canada.map((uni, index) => (
          <div
            key={`school-${index + 1}`}
            className="group relative bg-gradient-to-b from-white/[0.04] to-white/[0.01] backdrop-blur-md border border-white/[0.05] hover:border-brand-red/40 rounded-xl overflow-hidden shadow-2xl hover:scale-105 transition-all duration-300 aspect-square cursor-default"
          >
            <img
              src={uni.logo}
              alt={uni.name}
              className="absolute top-1/2 left-1/2 w-full h-full object-cover -translate-x-1/2 -translate-y-1/2 transition-transform duration-300 group-hover:scale-105"
              loading="lazy"
              onError={(e) => {
                e.target.style.display = "none";
                e.target.nextSibling.style.display = "flex";
              }}
            />

            <div className="hidden absolute inset-0 flex flex-col items-center justify-center p-4 text-center bg-dark-blue/90 z-10 pointer-events-none">
              <span className="text-xs font-manrope font-medium text-brand-beige line-clamp-2">
                {uni.name}
              </span>
            </div>

            <div className="absolute inset-0 rounded-xl pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20">
              <div className="absolute inset-0 rounded-xl bg-brand-red/10"></div>
            </div>
          </div>
        ))}

        <div className="group relative overflow-hidden rounded-xl border border-white/10 bg-gradient-to-br from-white/[0.06] via-white/[0.03] to-brand-red/10 backdrop-blur-xl shadow-2xl hover:border-brand-red/40 hover:-translate-y-1 hover:shadow-[0_20px_50px_rgba(220,38,38,0.18)] transition-all duration-500 aspect-square flex items-center justify-center cursor-default">
  {/* Background Glow */}
  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
    <div className="absolute inset-0 bg-gradient-to-br from-brand-red/15 via-transparent to-brand-red/5"></div>
  </div>

  {/* Content */}
  <div className="relative z-10 flex flex-col items-center text-center px-4">
    <div className="w-16 h-16 rounded-full border border-brand-red/30 bg-brand-red/10 flex items-center justify-center transition-all duration-500 group-hover:bg-brand-red group-hover:scale-110">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-7 h-7 text-brand-red group-hover:text-white transition-all duration-500 group-hover:rotate-90"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 5v14m7-7H5"
        />
      </svg>
    </div>

    <h4 className="mt-5 text-base font-semibold font-manrope text-brand-beige">
      Many More
    </h4>

    <p className="mt-2 text-xs text-gray-400 leading-relaxed max-w-[160px]">
      We are partnered with many more universities across the globe.
    </p>
  </div>

  {/* Bottom Accent */}
  <div className="absolute bottom-0 left-0 h-1 w-0 bg-brand-red transition-all duration-500 group-hover:w-full"></div>
</div>

      </div>
    </div>

    {/* Europe */}
    <div className="mb-16">
      <div className="flex items-center justify-between gap-4 mb-8">
        <div className="flex items-center gap-3">
          <div className="w-[3px] h-6 bg-brand-red rounded-full"></div>
          <h3 className="text-lg md:text-xl font-lora font-medium text-brand-beige tracking-wide">
            Europe
          </h3>
        </div>
        <div className="flex-1 h-[1px] bg-gradient-to-r from-gray-800 via-gray-800/30 to-transparent hidden sm:block"></div>
        <span className="text-[11px] font-manrope font-medium tracking-wider uppercase text-gray-400 bg-white/5 px-3 py-1 rounded-md border border-white/10">
          {universityData.europe.length}+ Institutions
        </span>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
        {universityData.europe.map((uni, index) => (
          <div
            key={`school-${index + 1}`}
            className="group relative bg-gradient-to-b from-white/[0.04] to-white/[0.01] backdrop-blur-md border border-white/[0.05] hover:border-brand-red/40 rounded-xl overflow-hidden shadow-2xl hover:scale-105 transition-all duration-300 aspect-square cursor-default"
          >
            <img
              src={uni.logo}
              alt={uni.name}
              className="absolute top-1/2 left-1/2 w-full h-full object-cover -translate-x-1/2 -translate-y-1/2 transition-transform duration-300 group-hover:scale-105"
              loading="lazy"
              onError={(e) => {
                e.target.style.display = "none";
                e.target.nextSibling.style.display = "flex";
              }}
            />

            <div className="hidden absolute inset-0 flex flex-col items-center justify-center p-4 text-center bg-dark-blue/90 z-10 pointer-events-none">
              <span className="text-xs font-manrope font-medium text-brand-beige line-clamp-2">
                {uni.name}
              </span>
            </div>

            <div className="absolute inset-0 rounded-xl pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20">
              <div className="absolute inset-0 rounded-xl bg-brand-red/10"></div>
            </div>
          </div>
        ))}

    <div className="group relative overflow-hidden rounded-xl border border-white/10 bg-gradient-to-br from-white/[0.06] via-white/[0.03] to-brand-red/10 backdrop-blur-xl shadow-2xl hover:border-brand-red/40 hover:-translate-y-1 hover:shadow-[0_20px_50px_rgba(220,38,38,0.18)] transition-all duration-500 aspect-square flex items-center justify-center cursor-default">
  {/* Background Glow */}
  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
    <div className="absolute inset-0 bg-gradient-to-br from-brand-red/15 via-transparent to-brand-red/5"></div>
  </div>

  {/* Content */}
  <div className="relative z-10 flex flex-col items-center text-center px-4">
    <div className="w-16 h-16 rounded-full border border-brand-red/30 bg-brand-red/10 flex items-center justify-center transition-all duration-500 group-hover:bg-brand-red group-hover:scale-110">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-7 h-7 text-brand-red group-hover:text-white transition-all duration-500 group-hover:rotate-90"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 5v14m7-7H5"
        />
      </svg>
    </div>

    <h4 className="mt-5 text-base font-semibold font-manrope text-brand-beige">
      Many More
    </h4>

    <p className="mt-2 text-xs text-gray-400 leading-relaxed max-w-[160px]">
      We are partnered with many more universities across the globe.
    </p>
  </div>

  {/* Bottom Accent */}
  <div className="absolute bottom-0 left-0 h-1 w-0 bg-brand-red transition-all duration-500 group-hover:w-full"></div>
</div>
      </div>
    </div>

    {/* Asia & Oceania */}
    <div>
      <div className="flex items-center justify-between gap-4 mb-8">
        <div className="flex items-center gap-3">
          <div className="w-[3px] h-6 bg-brand-red rounded-full"></div>
          <h3 className="text-lg md:text-xl font-lora font-medium text-brand-beige tracking-wide">
            Asia & Oceania
          </h3>
        </div>
        <div className="flex-1 h-[1px] bg-gradient-to-r from-gray-800 via-gray-800/30 to-transparent hidden sm:block"></div>
        <span className="text-[11px] font-manrope font-medium tracking-wider uppercase text-gray-400 bg-white/5 px-3 py-1 rounded-md border border-white/10">
          {universityData.asia.length}+ Institutions
        </span>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
        {universityData.asia.map((uni, index) => (
          <div
            key={`school-${index + 1}`}
            className="group relative bg-gradient-to-b from-white/[0.04] to-white/[0.01] backdrop-blur-md border border-white/[0.05] hover:border-brand-red/40 rounded-xl overflow-hidden shadow-2xl hover:scale-105 transition-all duration-300 aspect-square cursor-default"
          >
            <img
              src={uni.logo}
              alt={uni.name}
              className="absolute top-1/2 left-1/2 w-full h-full object-cover -translate-x-1/2 -translate-y-1/2 transition-transform duration-300 group-hover:scale-105"
              loading="lazy"
              onError={(e) => {
                e.target.style.display = "none";
                e.target.nextSibling.style.display = "flex";
              }}
            />

            <div className="hidden absolute inset-0 flex flex-col items-center justify-center p-4 text-center bg-dark-blue/90 z-10 pointer-events-none">
              <span className="text-xs font-manrope font-medium text-brand-beige line-clamp-2">
                {uni.name}
              </span>
            </div>

            <div className="absolute inset-0 rounded-xl pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20">
              <div className="absolute inset-0 rounded-xl bg-brand-red/10"></div>
            </div>
          </div>
        ))}

<div className="group relative overflow-hidden rounded-xl border border-white/10 bg-gradient-to-br from-white/[0.06] via-white/[0.03] to-brand-red/10 backdrop-blur-xl shadow-2xl hover:border-brand-red/40 hover:-translate-y-1 hover:shadow-[0_20px_50px_rgba(220,38,38,0.18)] transition-all duration-500 aspect-square flex items-center justify-center cursor-default">
  {/* Background Glow */}
  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
    <div className="absolute inset-0 bg-gradient-to-br from-brand-red/15 via-transparent to-brand-red/5"></div>
  </div>

  {/* Content */}
  <div className="relative z-10 flex flex-col items-center text-center px-4">
    <div className="w-16 h-16 rounded-full border border-brand-red/30 bg-brand-red/10 flex items-center justify-center transition-all duration-500 group-hover:bg-brand-red group-hover:scale-110">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-7 h-7 text-brand-red group-hover:text-white transition-all duration-500 group-hover:rotate-90"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 5v14m7-7H5"
        />
      </svg>
    </div>

    <h4 className="mt-5 text-base font-semibold font-manrope text-brand-beige">
      Many More
    </h4>

    <p className="mt-2 text-xs text-gray-400 leading-relaxed max-w-[160px]">
      We are partnered with many more universities across the globe.
    </p>
  </div>

  {/* Bottom Accent */}
  <div className="absolute bottom-0 left-0 h-1 w-0 bg-brand-red transition-all duration-500 group-hover:w-full"></div>
</div>
      </div>
    </div>
  </div>
</section>
      {/* Overview Section */}
      <section className="w-full py-28 md:py-40 px-4 md:px-6 bg-dark-blue relative overflow-hidden">
        {/* Background decorative glow */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute -top-24 -left-24 w-96 h-96 bg-brand-red/20 rounded-full blur-3xl animate-pulse-slow"></div>
          <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-brand-beige/20 rounded-full blur-3xl animate-pulse-slow"></div>
        </div>

        <div className="max-w-5xl mx-auto relative z-10 text-center">
          {/* Header */}
          <h2 className="text-5xl md:text-6xl font-bold font-lora text-white leading-tight tracking-tight mb-8">
            <span className="text-brand-beige">Overview</span>
          </h2>

          {/* Single Paragraph */}
          <p className="text-gray-300 text-lg md:text-xl leading-relaxed font-manrope">
            At{" "}
            <span className="text-brand-red font-semibold">
              Bridge International (BI)
            </span>
            , we provide{" "}
            <span className="text-brand-beige font-medium">
              internationally recognized education
            </span>{" "}
            at affordable prices, driven by a strong ambition to cultivate
            future leaders. Our programs are carefully designed to equip
            students with the{" "}
            <span className="text-brand-red font-semibold">
              knowledge, skills, and experience
            </span>{" "}
            necessary to succeed academically and personally. We offer{" "}
            <span className="text-brand-beige font-medium">
              comprehensive support including university counseling, extra
              academic assistance, volunteering opportunities, and
              extracurricular activities
            </span>
            , while ensuring every student benefits from{" "}
            <span className="text-brand-red font-semibold">
              enhanced facilities, services, and networking programs
            </span>{" "}
            that prepare them for top universities worldwide.
          </p>

          {/* Decorative accent */}
          <div className="flex justify-center items-center space-x-4 mt-12">
            <div className="w-32 h-1 bg-gradient-to-r from-transparent via-brand-beige to-transparent rounded-full"></div>
          </div>
        </div>
      </section>
      {/* Our Values Section */}
      <section className="w-full py-20 md:py-32 px-4 md:px-6 bg-gray-900 relative">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16 md:mb-24 space-y-6">
            <div className="w-20 h-1 bg-brand-red mx-auto rounded-full"></div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-lora text-white leading-tight">
              Our <span className="text-brand-red">Values</span>
            </h2>
            <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed font-manrope">
              The core principles that guide our educational mission and shape
              our community
            </p>
          </div>

          {/* Values Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 lg:gap-20">
            {/* Value 1 - Academic Excellence */}
            <div className="group space-y-6">
              <div className="flex items-start space-x-6">
                <div className="flex-shrink-0 w-16 h-16 bg-brand-red rounded-2xl flex items-center justify-center shadow-lg group-hover:shadow-xl transition-all duration-300">
                  <svg
                    className="w-8 h-8 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                    />
                  </svg>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl md:text-3xl font-bold font-lora text-white mb-4 group-hover:text-brand-red transition-colors duration-300">
                    Academic Excellence
                  </h3>
                  <p className="text-gray-300 leading-relaxed font-manrope">
                    We maintain the highest standards of education, ensuring our
                    students are prepared for the world's top universities and
                    future careers with rigorous academic programs.
                  </p>
                </div>
              </div>
            </div>

            {/* Value 2 - Global Community */}
            <div className="group space-y-6">
              <div className="flex items-start space-x-6">
                <div className="flex-shrink-0 w-16 h-16 bg-brand-red rounded-2xl flex items-center justify-center shadow-lg group-hover:shadow-xl transition-all duration-300">
                  <svg
                    className="w-8 h-8 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                    />
                  </svg>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl md:text-3xl font-bold font-lora text-white mb-4 group-hover:text-brand-red transition-colors duration-300">
                    Global Community
                  </h3>
                  <p className="text-gray-300 leading-relaxed font-manrope">
                    We foster an inclusive environment where students from
                    diverse backgrounds come together to learn, grow, and build
                    lifelong connections across cultures.
                  </p>
                </div>
              </div>
            </div>

            {/* Value 3 - Innovation & Growth */}
            <div className="group space-y-6">
              <div className="flex items-start space-x-6">
                <div className="flex-shrink-0 w-16 h-16 bg-brand-red rounded-2xl flex items-center justify-center shadow-lg group-hover:shadow-xl transition-all duration-300">
                  <svg
                    className="w-8 h-8 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13 10V3L4 14h7v7l9-11h-7z"
                    />
                  </svg>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl md:text-3xl font-bold font-lora text-white mb-4 group-hover:text-brand-red transition-colors duration-300">
                    Innovation & Growth
                  </h3>
                  <p className="text-gray-300 leading-relaxed font-manrope">
                    We encourage creative thinking, problem-solving, and
                    continuous learning to prepare students for an ever-evolving
                    world with cutting-edge methodologies.
                  </p>
                </div>
              </div>
            </div>

            {/* Value 4 - Pastoral Care */}
            <div className="group space-y-6">
              <div className="flex items-start space-x-6">
                <div className="flex-shrink-0 w-16 h-16 bg-brand-red rounded-2xl flex items-center justify-center shadow-lg group-hover:shadow-xl transition-all duration-300">
                  <svg
                    className="w-8 h-8 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                    />
                  </svg>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl md:text-3xl font-bold font-lora text-white mb-4 group-hover:text-brand-red transition-colors duration-300">
                    Pastoral Care
                  </h3>
                  <p className="text-gray-300 leading-relaxed font-manrope">
                    We provide comprehensive support for each student's
                    emotional, social, and personal development throughout their
                    educational journey with dedicated guidance.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Accent */}
          <div className="flex justify-center mt-16 md:mt-20">
            <div className="w-32 h-1 bg-gradient-to-r from-transparent via-brand-red to-transparent rounded-full"></div>
          </div>
        </div>
      </section>
      {/* News & Highlights Section */}
      <section className="w-full py-20 md:py-32 px-4 md:px-6 bg-dark-blue relative">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16 md:mb-20 space-y-6">
            <div className="w-20 h-1 bg-brand-red mx-auto"></div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-lora text-white leading-tight">
              News & <span className="text-brand-red">Highlights</span>
            </h2>
            <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed font-manrope">
              Stay updated with the latest achievements, events, and milestones
              from our Bridge International community
            </p>
          </div>

          {/* Blog Boxes Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-7xl mx-auto px-4">
            {blogs.map((blog) => (
              // <div
              //   key={blog.id}
              //   className="group relative bg-gray-900 overflow-hidden rounded-3xl shadow-2xl hover:shadow-brand-red/30 transition-all duration-500 hover:-translate-y-2"
              // >
              //   {/* Image */}
              //   <div className="relative w-full aspect-video overflow-hidden rounded-t-3xl">
              //     <img
              //       src={`${backend_domain_name}/public/storage/${blog.image}`}
              //       alt={blog.title}
              //       className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              //     />
              //     <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
              //     <div className="absolute top-4 left-4">
              //       <span className="bg-brand-red text-white px-3 py-1 text-sm font-semibold font-manrope rounded-full shadow-sm">
              //         {blog.category}
              //       </span>
              //     </div>
              //   </div>

              //   {/* Content */}
              //   <div className="p-4 md:p-6 space-y-3">
              //     <h3 className="text-lg md:text-xl font-bold font-lora text-white group-hover:text-brand-red transition-colors duration-300">
              //       {blog.title}
              //     </h3>
              //     <p className="text-gray-400 font-manrope text-sm md:text-base leading-relaxed line-clamp-3">
              //       {blog.description}
              //     </p>
              //     <div className="flex items-center justify-between pt-3">
              //       <span className="text-brand-beige text-xs md:text-sm font-manrope">
              //         {new Date(blog.date).toLocaleDateString("en-US", {
              //           year: "numeric",
              //           month: "long",
              //           day: "numeric",
              //         })}
              //       </span>
              //       {/* <div className="w-8 h-8 bg-brand-red flex items-center justify-center rounded-full group-hover:bg-brand-beige transition-colors duration-300 shadow-md hover:shadow-lg cursor-pointer">
              //         <svg
              //           className="w-4 h-4 text-white group-hover:text-gray-900 transition-colors duration-300"
              //           fill="none"
              //           stroke="currentColor"
              //           viewBox="0 0 24 24"
              //         >
              //           <path
              //             strokeLinecap="round"
              //             strokeLinejoin="round"
              //             strokeWidth={2}
              //             d="M17 8l4 4m0 0l-4 4m4-4H3"
              //           />
              //         </svg>
              //       </div> */}
              //     </div>
              //   </div>
              // </div>
              <div
                key={blog.id}
                className="group relative bg-gray-900 overflow-hidden rounded-3xl shadow-2xl hover:shadow-brand-red/30 transition-all duration-500 hover:-translate-y-2"
              >
                {/* Image */}
                <div className="relative w-full aspect-video overflow-hidden rounded-t-3xl">
                  <img
                    src={`${new_backend_domain_name}/public/storage/${blog.image}`}
                    alt={blog.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
                  <div className="absolute top-4 left-4">
                    <span className="bg-brand-red text-white px-3 py-1 text-sm font-semibold font-manrope rounded-full shadow-sm">
                      {blog.category}
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div className="p-4 md:p-6 space-y-3">
                  <h3 className="text-lg md:text-xl font-bold font-lora text-white group-hover:text-brand-red transition-colors duration-300">
                    {blog.title}
                  </h3>

                  {/* Description */}
                  <div
                    className={`text-gray-400 font-manrope text-sm md:text-base leading-relaxed transition-all duration-500 overflow-hidden`}
                    style={{
                      maxHeight: expanded ? "1000px" : "4.5rem", // about 3 lines
                    }}
                  >
                    {blog.description}
                  </div>

                  {/* Read More / Less button */}
                  <button
                    onClick={() => setExpanded(!expanded)}
                    className="flex items-center gap-1 text-sm font-semibold px-3 py-1.5 rounded-full 
             bg-gray-800 text-white hover:bg-brand-red hover:text-white 
             transition-all duration-300 mt-2"
                  >
                    {expanded ? (
                      <>
                        Read Less <span className="text-xs">▲</span>
                      </>
                    ) : (
                      <>
                        Read More <span className="text-xs">▼</span>
                      </>
                    )}
                  </button>

                  <div className="flex items-center justify-between pt-3">
                    <span className="text-brand-beige text-xs md:text-sm font-manrope">
                      {new Date(blog.date).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Ready to Apply CTA Section */}
      <section className="w-full relative bg-cover bg-center bg-no-repeat min-h-screen flex items-center">
        <img
          src="https://bic-bangkok.vercel.app/crowd5.jpg"
          alt="Graduation and Success"
          className="absolute inset-0 w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-brand-red/30 to-black/90"></div>

        {/* Content */}
        <div className="relative z-10 w-full py-20 md:py-32 px-4 md:px-6">
          <div className="max-w-5xl mx-auto text-center space-y-10 md:space-y-12">
            <div className="space-y-6">
              <h2 className="text-5xl md:text-7xl lg:text-8xl font-bold font-lora text-white leading-tight tracking-tight">
                Ready to <span className="text-brand-red">Apply?</span>
              </h2>
            </div>
            <p className="text-xl md:text-2xl lg:text-3xl text-brand-beige leading-relaxed max-w-4xl mx-auto font-light font-manrope">
              Become part of a community where your success comes first. With
              personalized learning, cutting-edge facilities, and a supportive
              environment, we are dedicated to unlocking each student's full
              potential.
            </p>
            <div className="pt-8">
              <Link
                to="/enquire"
                className="group inline-flex items-center px-12 md:px-16 py-6 md:py-8 bg-brand-red hover:bg-brand-red/90 text-white font-bold text-xl md:text-2xl shadow-2xl hover:shadow-brand-red/50 transition-all duration-300 hover:scale-105 hover:-translate-y-1 border-2 border-brand-red hover:border-brand-beige rounded-lg"
              >
                APPLY NOW
                <svg
                  className="w-8 h-8 ml-4 group-hover:translate-x-2 transition-transform duration-300"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                  />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
